import { Team, DtoTeam } from '@web-portal/domains/shared/domain-models';
import { TeamBuilder } from '@web-portal/domains/team/team-seatmap';

export class TeamMapper {
  static mapToTeam(teamData: unknown): Team {
    if (!TeamMapper.isTeam(teamData)) {
      console.error('[TeamMapper]: Invalid team data:', teamData);
      return {} as unknown as Team;
    }

    const teamBuilder = new TeamBuilder()
      .withId(teamData.id)
      .withName(teamData.name)
      .withSlug(teamData.slug)
      .withIsMyTeam(teamData.ismyteam);

    return teamBuilder.build();
  }

  /**
   * Validates if the provided data conforms to the Team interface.
   * @param teamData
   * @returns boolean
   */
  static isTeam(teamData: unknown): teamData is Required<DtoTeam> {
    return (
      typeof teamData === 'object' &&
      teamData !== null &&
      'slug' in teamData &&
      'id' in teamData &&
      'ismyteam' in teamData &&
      'name' in teamData
    );
  }
}
